module.exports = __webpack_public_path__ + "src/client/screens/MessageBank/message_bank_empty.svg";